export default {
  signIn: 'ログイン',
  signOut: 'ログアウト',
  points: 'ポイント',
  hyattSignInButton: 'World of Hyattにサインイン',
};
